import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export default class ErrorInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                let userMessage =
                    "Uh-oh! We're experiencing a technical problem. Please try again later.";

                if (error.error?.message) {
                    userMessage = error.error.message;
                }

                return throwError(() => ({
                    ...error,
                    userMessage,
                }));
            })
        );
    }
}
